module.exports = __webpack_public_path__ + "media/images/features/support/heading-refund-1cd620785eda429b08ba5a84ded4bf66.svg";